import PropTypes from 'prop-types';
import React from 'react';
import { pageContext } from 'ctm-util-functions';
import { List } from 'immutable';

import { SimpleFlexbox } from '../../../../../flexbox/flexbox';
import { Text } from '../../../../../text/text';
import { BrandLogo } from '../../../../../brand_logo/brand_logo';

import style from '../features_header/features_header.css';

/**
 * Displays a FeaturesHeaderNotAvailableList with Brand Logos of unavailable quotes
 * @param {Object} args The arguments
 * @param {Immutable.List} args.unavailableBrands - list of brands that weren't available
 * @param {Object} args.contentProps - contentProps for Text component from schema
 * @param {Object} args.visualProps - visualProps for Text component from schema
 * @returns {Node} A featuresHeaderNotAvailable Component
 * @constructor
 */
const FeaturesHeaderNotAvailableList = ({ unavailableBrands, contentProps, visualProps }) => {
    /**
     * Iterates through  the unavailable quotes returning a flexbox containing the product name and Brand Logo
     * @returns {FeaturesHeaderNotAvailableList} A FeaturesHeaderNotAvailableList Component
     */
    const vertical = pageContext.getVertical();
    const brandLogoElementProps = { srcPath: `/evt/assets/images/logos/${vertical}` };

    return unavailableBrands.size > 0 ? (
        <div className={style.notAvailableList}>
            <SimpleFlexbox padding="all">
                { /* @TODO remove shaped props from parent once we get to that stage */ }
                <Text {...contentProps} {...visualProps} />
            </SimpleFlexbox>
            {unavailableBrands.map((brand) => (
                <SimpleFlexbox key={brand.getIn(['providerMeta', 'code'])} padding="all_small">
                    <BrandLogo
                        stateProps={{ product: brand }}
                        elementProps={brandLogoElementProps} />
                    { /* <Text {...visualProps}>{brand.getIn(['providerMeta', 'name'])}</Text> */ }
                </SimpleFlexbox>
            )
            )}
        </div>
    ) : null;
};

FeaturesHeaderNotAvailableList.propTypes = {
    unavailableBrands: PropTypes.instanceOf(List).isRequired,
    contentProps: PropTypes.object.isRequired,
    visualProps: PropTypes.object
};

export { FeaturesHeaderNotAvailableList };
